import {Dialog, openConfirmDialog} from 'platform/components';

import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';
import {warehouseRoutes} from '@dms/routes';
import {logError} from '@dms/shared';

import {composePath, pushGtmEvent, useBoolean, useNavigate} from 'shared/web';

import {DeliveryNoteDocumentPreview} from './DeliveryNoteDocumentPreview';

export function DeliveryNoteDocumentPreviewDialog() {
  const {id} = useParams();

  const navigate = useNavigate();

  const [isOpen, , onClose] = useBoolean(true);

  useEffect(
    function logMissingId() {
      if (isNil(id)) {
        logError('id is not defined');
      }
    },
    [id]
  );

  const handleClose = () => {
    pushGtmEvent({
      event: 'button_click',
      event_id: 'ai_tool_dn_import_dialog_confirm_close',
    });
    onClose();
    navigate(composePath(warehouseRoutes.deliveryNoteList));
  };

  return (
    <Dialog
      isOpen={isOpen}
      title={i18n.t('entity.documentExtraction.labels.documentPreview')}
      size="xLarge"
      withAdditionalFooter
      onClose={() => {
        pushGtmEvent({
          event: 'button_click',
          event_id: 'ai_tool_dn_import_dialog_close',
        });
        openConfirmDialog({
          text: i18n.t('entity.documentExtraction.notifications.closeDialogConfirmation'),
          onConfirm: handleClose,
        });
      }}
    >
      {/* eslint-disable-next-line eag/prefer-show -- Pre-existing violation */}
      {isNil(id) ? null : <DeliveryNoteDocumentPreview messageId={id} onClose={handleClose} />}
    </Dialog>
  );
}
